import ProjectDisciplinesConfig from './ProjectDisciplinesConfig'

export default ProjectDisciplinesConfig
